import { WireNameValue } from 'scenes/common/api/quote/types';

export const toNameValueIfExists = (
  name: string,
  value: string | undefined
): WireNameValue[] =>
  value
    ? [
        {
          name,
          value,
        },
      ]
    : [];
